import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router";
import { useAuth } from "./hooks/useAuth";
import { AuthWrapper } from "./components/AuthWrapper";
import { DevToolsPanel } from "./components/DevToolsPanel";
import { LoadingSpinner } from "./components/LoadingSpinner";
import { getEnvironment } from "./utils/environment";
import { QueryProvider } from "./providers/QueryProvider";
import { LingoProvider } from "./providers/LingoProvider";
import { BUIProvider } from "./providers/BUIProvider";

const InnerApp = () => {
  const authInfo = useAuth();

  if (authInfo.isLoading) {
    return <LoadingSpinner />;
  }

  return <RouterProvider router={router} context={{ auth: authInfo }} />;
};

const App = () => {
  const environment = getEnvironment();

  return (
    <QueryProvider>
      <LingoProvider>
        <BUIProvider>
          <AuthWrapper>
            <InnerApp />
          </AuthWrapper>
          {environment.internal && <DevToolsPanel environment={environment} />}
        </BUIProvider>
      </LingoProvider>
    </QueryProvider>
  );
};

export default App;
